import { createSlice } from "@reduxjs/toolkit";

import { getDiscountList, addDiscountList, updateDiscountList, deleteDiscountList } from "./thunk";

export const initialState = {
    discountList: {
        content: []
    },
    errors: {}
};

const DiscountSlice = createSlice({
    name: 'Discount',
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder.addCase(getDiscountList.fulfilled, (state: any, action: any) => {
            state.discountList = action.payload;
        });
        builder.addCase(getDiscountList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(addDiscountList.fulfilled, (state: any, action: any) => {
            console.log(action.payload)
            state.discountList.content.unshift(action.payload);
        });
        builder.addCase(addDiscountList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(updateDiscountList.fulfilled, (state: any, action: any) => {
            state.discountList.content = state.discountList.content.map((category: any) =>
                category.id === action.payload.id
                    ? { ...category, ...action.payload }
                    : category
            );
        });

        builder.addCase(updateDiscountList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(deleteDiscountList.fulfilled, (state: any, action: any) => {
            state.discountList.content = state.discountList.content.filter(
                (discountList: any) => discountList.id !== action.payload
            );
            console.log(action.payload)
        });
        builder.addCase(deleteDiscountList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
    }
});

export default DiscountSlice.reducer;